import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { callGetWebservice } from '../hooks/api';
import { setUser } from '../store/reducers/auth';
import { userData } from '../utils/constants';
import { saveToLocalStorage } from '../utils/localStorageUtils';

const SocialAuthCallback = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { provider } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const authenticateUser = async () => {
            if (provider) {
                const searchParams = window.location.search;
                const requestType = 'Website';
                const endpoint = `social-auth/${provider}/callback${searchParams}${searchParams ? '&' : '?'}request_type=${requestType}`;

                try {
                    callGetWebservice(
                        endpoint,
                        {},
                        (response) => {

                            if (response.data) {
                                dispatch(setUser(response.data));
                                saveToLocalStorage(userData, response.data);
                            }

                            window.location.href = '/';
                        },
                        (errorData) => {
                            setError(errorData.errMessage);
                            setIsLoading(false);
                            setTimeout(() => {
                                window.location.href = '/';
                            }, 3000);
                        },
                        dispatch,
                        navigate
                    );

                } catch (error) {
                    console.error('Authentication failed', error);
                    setError('Authentication failed. Redirecting...');
                    setIsLoading(false);
                    setTimeout(() => {
                        window.location.href = '/';
                    }, 3000);
                }
            }
        };

        authenticateUser();
    }, [provider, navigate, dispatch]);

    if (isLoading) {
        return (
            <div className="page-loader">
                <div className="loader-content">
                    <div className="loader-spinner">
                        <i className="fas fa-spinner fa-spin"></i>
                    </div>
                    <h3>Loading...</h3>
                    <p>Please wait while we set things up</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="page-error">
                <div className="error-content">
                    <div className="error-icon">
                        <i className="fas fa-exclamation-circle"></i>
                    </div>
                    <h3>Oops! Something went wrong</h3>
                    <p>{error}</p>
                    <p>Redirecting to home page in 3 seconds...</p>
                </div>
            </div>
        );
    }

    return null;
};

export default SocialAuthCallback;